import axios from 'axios';

// Determina dinamicamente a URL da API:
// 1. No navegador (Web): conecta na mesma origem (IP, localhost ou domínio atual)
// 2. No aplicativo Mobile/Emulador: usa o IP da VPS atual
const getBaseUrl = () => {
    if (typeof window !== 'undefined' && window.location) {
        const { hostname, origin } = window.location;
        const isNative = Boolean(window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform());
        // Se estiver rodando no navegador (qualquer porta, IP ou domínio acessado, exceto localhost/Capacitor)
        if (!isNative && hostname && hostname !== 'localhost' && hostname !== '127.0.0.1' && !origin.includes('localhost:3000')) {
            return `${origin}/api`;
        }
    }
    // Fallback padrão para mobile / app empacotado (Nova VPS)
    return 'https://wadesk.vps12569.panel.icontainer.website/api';
};

const api = axios.create({
    baseURL: getBaseUrl(),
    timeout: 15000
});

api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            console.warn('[API] Sessão expirada ou não autorizada. Limpando sessão local.');
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default api;
